import iconVk from './img/Vector-Vk.svg'
import iconVkBlack from './img/Vector-Vk-Black.svg'
import iconInsta from './img/Vector-Insta.svg'
import iconInstaBlack from './img/Vector-Insta-Black.svg'

import galeryImg1 from "./../src/img/7qeh6tavC90.png";
import galeryImg2 from "./../src/img/cmpi2NpbEgk.png";
import galeryImg3 from "./../src/img/D5FVjtM-iFY.png";
import galeryImg4 from "./../src/img/s5nOKZygs-I.png";
import galeryImg5 from "./../src/img/YYXbeZ-sZSo.png";
import galeryImg6 from "./../src/img/zbUAo5yPRFU.png";

  export const NavbarItems = [
    {
      linkName: 'Прайс',
      linkUrl: '/#Price-list',
    },
    {
      linkName: 'Отзывы',
      linkUrl: '/#Gallery',
    },

    {
      linkName: 'Контакты',
      linkUrl: '/#Contacts',
    },
  ]
  
  export const SocialItems = [
    {
      linkUrl: 'https://vk.com/',
      icon: iconVk,
      iconBlack: iconVkBlack
    },
    {
      linkUrl: 'https://www.instagram.com/',
      icon: iconInsta,
      iconBlack: iconInstaBlack
    }
  ]

  export const PriceListButtons = [
    {
      id : 1,
      btnName: 'маникюр'
    },

    {
      id : 2,
      btnName: 'педикюр'
    },

    {
      id : 3,
      btnName: 'ресницы'
    },

    {
      id : 4,
      btnName: 'брови'
    },
  ]

  export const ListServices = [
    {
      id: 1,
      "Маникюр без покрытия": "1100 ₽",
      "Маникюр с покрытием гель-лак (снятие наращивания входит в стоимость)": "1900 ₽",
      "Маникюр с покрытием лак ": "1400 ₽",
      "Ремонт 1 ногтя": "100 ₽",
      "Наращивание 1 ногтя": "200 ₽",
      "Укрепление ногтей пудрой": "300 ₽",
      "Лечебное покрытие IBX": "300 ₽",
      "Парафинотерапия рук": "600 ₽",
      "Мужской маникюр": "1100 ₽",
      "Французское | лунное покрытие": "500 ₽",
      "Втирка | стразы | простой дизайн": "от 100 ₽",
      "Дизайн 1 ногтя сложный": "250 ₽",
      "СЕТ ПРЕМИУМ В 4 РУКИ доплата": "400 ₽",
      "СЕТ ПРЕМИУМ В 6 РУК доплата": "600 ₽",
    },
    {
      'id': '2',
      "Педикюр гигиенический SMART (обработка пальцев + полная обработка стопы)": "900 ₽",
      "Экспресс педикюр (обработка пальцев ног)": "1600 ₽",
      "Педикюр SMART с покрытием гель-лак (снятие входит в стоимость)": "2400 ₽",
      "Экспресс педикюр с покрытием гель-лак": "2100 ₽",
      "Покрытие лак": "300 ₽",
      "Французское | лунное покрытие": "500 ₽",
      "Втирка | стразы | простой дизайн": "от 100 ₽",
      "Дизайн 1 ногтя сложный": "250 ₽",
      "СЕТ ПРЕМИУМ В 4 РУКИ доплата": "400 ₽",
      "СЕТ ПРЕМИУМ В 6 РУК доплата": "600 ₽",
    },
    {
      id: 3,
      "Наращивание ресниц классическое": "2100 ₽",
      "Наращивание ресниц 1.5D": "2400 ₽",
      "Наращивание ресниц 2D": "2600 ₽",
      "Наращивание ресниц 3D": "2900 ₽",
      "Снятие нашей работы с последующим наращиванием": "бесплатно",
      "Снятие чужой работы с последующим наращиванием": "300 ₽",
      "Снятие ресниц": "500 ₽",
      "Коррекция ресниц": "500 ₽ от стоимости наращивания",
      "Окрашивание ресниц": "500 ₽",
      "Ламинирование ресниц": "1800 ₽",
    },
    {
      id: 4,
      "Коррекция + окрашивание краской | хной": "1100 ₽",
      Коррекция: "700 ₽",
      "Окрашивание краской | хной": "600 ₽",
      Ламинирование: "1400 ₽",
      "Ламинирование + коррекция + окрашивание": "1900 ₽",
      "Ботокс (счастье для бровей)": "400 ₽",
    },
  ]

  export const GalleryImg = [
    { galeryImg: galeryImg1 },
    { galeryImg: galeryImg2 },
    { galeryImg: galeryImg3 },
    { galeryImg: galeryImg4 },
    { galeryImg: galeryImg5 },
    { galeryImg: galeryImg6 },
  ]

  export const OfficeRulesList = [
    {
      header: 'Опоздание',
      content: 'Далеко-далеко за словесными горами, в стране гласных и согласных живут рыбные тексты. Домах пустился снова свое первую текстов, то языкового путь возвращайся свой власти за, семантика собрал гор дорогу на берегу свою моей?....'
    },

    {
      header: 'Отказ в предоставлении услуг',
      content: 'Далеко-далеко за словесными горами, в стране гласных и согласных живут рыбные тексты. Домах пустился снова свое первую текстов, то языкового путь возвращайся свой власти за, семантика собрал гор дорогу на берегу свою моей?....'
    },

    {
      header: 'Дизайны',
      content: 'Далеко-далеко за словесными горами, в стране гласных и согласных живут рыбные тексты. Домах пустился снова свое первую текстов, то языкового путь возвращайся свой власти за, семантика собрал гор дорогу на берегу свою моей?....'
    }, 

    {
      header: 'Сертификат',
      content: 'Далеко-далеко за словесными горами, в стране гласных и согласных живут рыбные тексты. Домах пустился снова свое первую текстов, то языкового путь возвращайся свой власти за, семантика собрал гор дорогу на берегу свою моей?....'
    }
  ]